import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	AfterViewInit,
	ChangeDetectorRef
} from "@angular/core";
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";
import { HomeComponent } from "../home/home.component";
import { GlobalService } from "../../services/global/global.service";
import { Router, NavigationStart } from "@angular/router";
import { AppUtil } from "../../utils/app.util";
import { Observable } from "rxjs";
import { AppConfigUtil } from "src/app/utils/app-config.util";
import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
@Component({
	selector: "app-base",
	templateUrl: "./base.component.html",
	styleUrls: ["./base.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseComponent implements OnInit, AfterViewInit {
	public isHomePage: boolean = false;
	public isCallFromQRCode: boolean;
	public isCallFromDirectURL: boolean;
	public agencyConfig: AgencyDmvConfigResponse;
	public isAnnouncementPageVisible: boolean;
	constructor(
		private router: Router,
		private cd: ChangeDetectorRef,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService
	) {}

	ngOnInit() {
		AppUtil.log(
			"base ngOnInit: this.globaService.isQRCall$ = " +
				this.globalService.getQrCall()
		);

		this.dmvStoreService.agencyConfig$.subscribe(agencyConfig => {
			if (agencyConfig) {
				this.agencyConfig = agencyConfig;
			}
		});
		//this.isCallFromQRCode$ = this.globalService.isQRCall$();
		this.globalService.isQRCall$().subscribe(val => {
			this.isCallFromQRCode = val;
			if (val || this.isHomePage) {
				document.body.classList.add("global-home");
			} else {
				document.body.classList.remove("global-home");
			}
			this.cd.detectChanges();
		});

		this.globalService.isDirectURLCall$().subscribe(val => {
			this.isCallFromDirectURL = val;
			if (val || this.isHomePage) {
				document.body.classList.add("global-home");
			} else {
				document.body.classList.remove("global-home");
			}
			this.cd.detectChanges();
		});

		this.globalService.isAnnouncementPageVisible$().subscribe(val => {
			this.isAnnouncementPageVisible = val;
			this.cd.detectChanges();
		});

		this.router.events.subscribe(val => {
			if (val instanceof NavigationStart) {
				if (val.url === "/home") {
					this.isHomePage = true;
					document.body.classList.add("global-home");
					this.cd.detectChanges();
				} else {
					if (
						(this.isCallFromDirectURL || this.isCallFromQRCode) &&
						val.url !== "/app-announcement"
					) {
						document.body.classList.add("global-home");
					} else {
						document.body.classList.remove("global-home");
					}
					this.isHomePage = false;
					this.cd.detectChanges();
				}
			}
		});
		this.globalService.toggleHeaderDisplay(false);
		AppUtil.log(
			"BaseComponent ngOnInit: this.globalService.isHeaderDisplayed$ = ",
			this.globalService.getHeaderDisplayedValue()
		);
		//this.router.navigate(["home"]);
	}
	ngAfterViewInit() {
		this.globalService.toggleHeaderDisplay(false);
		AppUtil.log(
			"BaseComponent ngAfterViewInit: this.globalService.isHeaderDisplayed$ = " +
				this.globalService.getHeaderDisplayedValue()
		);

		if (window["qrDetail"] && AppConfigUtil.getProperties().qrCodeEnabled) {
			this.globalService.setQrCall(true);
		} else if (window["entryPointParams"] || window["externallink"]) {
			this.globalService.params =
				window["entryPointParams"] || window["externallink"];
			if (
				window["externallink"] &&
				(window["externallink"].entryPointID === "10" ||
					window["externallink"].entryPointID === "11")
			) {
				this.globalService.loginExternalLink = true;
				this.globalService.isAnnouncementFlow = false;
			}

			this.globalService.setDirectURLCall(true);
			// if (!this.agencyConfig.agencyDmvConfig.homogeneousCart) {
			// 	this.globalService.cartNature = "TBD";
			// } else {
			// 	this.globalService.cartNature =
			// 		this.globalService.params.deliveryMethodID === "2" ? "manual" : "TBD";
			// }
		}
		this.router.navigate(["home"], { skipLocationChange: true });
	}
}
